export default __webpack_public_path__ + "static/media/sticker-bo.843cdc42.png";